import React, { FC, useMemo } from 'react';
import { DropdownControl, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { NewMessagePageState } from '../../../../../../../interfaces/NewMessagePageState';
import { Subject } from '../../../../../../../interfaces/Subject';
import { StyledText } from '../../../../../NewMessagePage.styles';
import useDefaultValue from '../../../../useDefaultValue';

export interface SubjectsControlProps { disabled?: boolean }

const SubjectsControl: FC<SubjectsControlProps> = ({ disabled }) => {
  const { t } = useTranslation('NewMessagePage');

  const subjects = useScopedSelector((state: NewMessagePageState) => state.subjects || []);

  const subjectsOptions = useMemo(() => subjects.map((s) => ({
    label: s.description,
    value: s,
    key: 'id',
  })), [subjects]);

  const defaultValue = useDefaultValue('defaultsubject', subjectsOptions);

  return (
    <StyledText>
      <DropdownControl<Subject>
        disabled={disabled}
        required={!disabled}
        name="subject"
        aria-label={t('subject')}
        options={subjectsOptions}
        defaultValue={defaultValue}
      />
    </StyledText>
  );
};

export default SubjectsControl;
